import { RatingCGType } from '@/types/graphql/root';
import GoogleLogo from '@/images/google.png';
import TripAdvisorLogo from '@/images/tripadvisor.png';
import Image from 'next/image';
import Stars from './stars';
import LinkForZzimcarAndroid from '../common/link-for-zzimcar-android';

export default function Rating({ type, rating }: { type: 'google' | 'tripadvisor'; rating: RatingCGType | null }) {
  if (!rating) {
    return null;
  }

  return (
    <div className='flex flex-row items-center'>
      <LinkForZzimcarAndroid
        href={rating?.url ?? ''}
        prefetch={false}
        target='_blank'
        className='flex flex-row items-center gap-4pxr h-20pxr'
      >
        <div className='w-30pxr h-20pxr'>
          {type === 'google' && <Image src={GoogleLogo} alt='google_logo' width={20} height={20} className='mx-auto' />}
          {type === 'tripadvisor' && (
            <Image src={TripAdvisorLogo} alt='google_logo' width={30} height={20} className='mx-auto' />
          )}
        </div>
        {rating?.rating ? (
          <Stars type={type} rating={rating.rating} />
        ) : (
          <div className='h-16pxr w-80pxr skeleton-item rounded-2pxr' />
        )}
        {rating?.rating ? (
          <p className='text-gray-700 body-12-r'>
            {rating.rating}
            {rating.count && <span className='text-gray-500'> ({rating.count})</span>}
          </p>
        ) : (
          <div className='h-16pxr w-55pxr skeleton-item rounded-2pxr' />
        )}
      </LinkForZzimcarAndroid>
    </div>
  );
}
